const AVAILABILITY_TYPE = [
    {
        name: 'parttime',
        id: 2,
        displayName: 'Part Time'
    },
    {
        name: 'fulltime',
        id: 3,
        displayName: 'Full Time'
    },
    {
        name: 'pre-fulltime',
        id: 6,
        displayName: 'I can start part-time and then switch to full-time'
    },
    {
        name: 'unknown',
        id: 1,
        displayName: 'Not Available'
    }
]

const getAvailabilityId = (name) => {
    const match = AVAILABILITY_TYPE.filter(t => t.name === name);
    if (match && match.length) return match[0].id;

    return null;
}

const getAvailabilityName = (id) => {
    const match = AVAILABILITY_TYPE.filter(t => t.id === id);
    if (match && match.length) return match[0].name;

    return null;
}

const getAvailabilityDisplayName = (name) => {
    const match = AVAILABILITY_TYPE.filter(t => t.name === name);
    if (match && match.length) return match[0].displayName;
}

const AVAILABILITY_TYPE_NAMES = AVAILABILITY_TYPE.reduce((acc, c) => { acc[c.name.replace(/-/g, '_').toUpperCase()] = c.name; return acc; }, {});

const AVAILABILITY_STATUS = [
    'ready-to-interview',
    'open-to-offers',
    'not-looking-for-job',
    'unknown'
]

const AVAILABILITY_STATUS_NAMES = AVAILABILITY_STATUS.reduce((acc, c) => { acc[c.replace(/-/g, '_').toUpperCase()] = c; return acc; }, {});
export {
    getAvailabilityId,
    getAvailabilityName,
    getAvailabilityDisplayName,
    AVAILABILITY_TYPE_NAMES,
    AVAILABILITY_STATUS_NAMES
}